/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `SIGNED_PO` - Upon receipt of signed PO
* `SIGNED_PO_AND_PREINSPECTION` - Upon receipt of signed PO and successful Pre-inspection
* `COLLECTION` - Collection from Supplier
* `PREINSPECTION_AND_COLLECTION` - After successful Pre-inspection + Collection from Supplier
 */
export type DepositPaymentEvent = typeof DepositPaymentEvent[keyof typeof DepositPaymentEvent];


export const DepositPaymentEvent = {
  SIGNED_PO: 'SIGNED_PO',
  SIGNED_PO_AND_PREINSPECTION: 'SIGNED_PO_AND_PREINSPECTION',
  COLLECTION: 'COLLECTION',
  PREINSPECTION_AND_COLLECTION: 'PREINSPECTION_AND_COLLECTION',
} as const;
